'use client'
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";
import { useEffect } from "react";


const htmlSerializerOffer = (richText) => {

  const htmlSerializer = ({ type, text, spans }, i, arr) => {
    switch (type) {
      case 'heading4': {
        return `<div class="offer-header flex flex-row justify-between items-center"><h4> ${text} 
              </h4><div class="spin_arrow">
              <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 0.999999L8.25 7.75L15 1" stroke="#2E2E2D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </div></div>`;
      }
      case 'strong':
      case 'paragraph': {
        if (arr[i - 1]?.type === 'heading4') {
          return `<div class="offer-container overflow-hidden"><p>${text}</p>`
        }
        if (arr[i + 1]?.type === 'heading4' || i + 2 === richText.length) {
          return `<p>${text}</p></div>`
        }
        if (i + 1 === richText.length) {
          return `<div class="offer-footer"><p>${text}</p></div>`
        }
        return `<p>${text}</p>`
      }
    }
  }
  const v = richText.map((item, i, arr) => {
    var h = htmlSerializer(item, i, arr)
    return h
  });
  return v.join('');
}


const OfferConceptItem = ({ item, i, index }) => {

  return <div
    className={`w-full flex flex-col justify-center mb-10 lg:mb-5 ${i % 3 == 0 ? 'beige' : i % 2 ? 'green' : 'pink'} relative`}>
    <div className="border-x-2 border-t-2 border-dark-grey w-fit">
      <PrismicImage field={item.logo} className="w-[100px] h-[100px] object-contain"   loading={index === 0 ? '' : 'lazy'}/>
    </div>
    <div className="w-full md:w-[500px] lg:w-full offer-element rounded-tr-[30px] border-2 border-solid border-dark-grey">
      <div className="p-30px md:p-10 offer-element-header rounded-tr-[30px]">
        <div className="offer-element-title mb-2"><PrismicRichText field={item.title} /></div>
        <div className="offer-element-subtitle"><PrismicRichText field={item.text} /></div>
      </div>
      <div className="text-center offer-content" dangerouslySetInnerHTML={{ __html: htmlSerializerOffer(item.content) }}>
      </div>
    </div>
  </div>
}

/**
 * @typedef {import("@prismicio/client").Content.OfferConceptSlice} OfferConceptSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<OfferConceptSlice>} OfferConceptProps
 * @param {OfferConceptProps}
 */
const OfferConcept = ({ slice, index, context }) => {
  useEffect(() => {

    function toggleOffers(elems) {
      elems.forEach((elem) => {

        elem.addEventListener('click', function (e) {
          e.stopPropagation();
          this.querySelector('.spin_arrow').classList.toggle('toggle-active');
          this.nextElementSibling.classList.toggle('slide');
          if (this.classList.contains('offer-header-bottom')) {
            const timeOut = setTimeout((_) => {
              this.classList.remove('offer-header-bottom')
            }, 300)
            return () => clearTimeout(timeOut);
          } else {
            this.classList.add('offer-header-bottom')
          }
        })
        if (!context.isMobileViewer) {
          elem.querySelector('.spin_arrow').classList.toggle('toggle-active');
          elem.nextElementSibling.classList.toggle('slide');
          elem.classList.add('offer-header-bottom')
        }

      }, [])
    }
    const $offerHeader = document.querySelectorAll(".offer-header");

    if ($offerHeader !== null) {
      toggleOffers($offerHeader)
    }

  });
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white bg-grain border-t-2 border-dark-grey ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="px-4 py-10 md:py-20 md:px-7 lg:px-10 max-w-[1400px] m-auto">
        <div className="h2-like text-left md:text-center mb-8 md:mb-[90px]">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div className="flex justify-center">
          <div className="flex flex-col lg:flex-row content-start items-start justify-center lg:gap-10">
            {
              slice.primary.offers.map((item, i) => <OfferConceptItem key={i} item={item} index={index} i={i} isMobileViewer={context.isMobileViewer} />)
            }
          </div>
        </div>
        <div className="text-center">
          <div className="button button-rounded button-text overflow-hidden background-slide-white">
            <PrismicLink field={slice.primary.cta_page} className="cta_form">{slice.primary.cta_label}</PrismicLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferConcept;
